import React, { useState, useEffect } from 'react';
import './style.sass';
import { useForm } from "react-hook-form";
import { InputTypeAndroid } from 'components/Forms/InputType';
import { ModalError } from 'components/Error/ErrorModal'
import {STAGE_DIRNAME } from 'constants/general'

export function TarjetaSears(props) {
    const {
        setAddCard,
        errorCode
    } = props

    let urlRFC
    if(STAGE_DIRNAME === "dev"){
        urlRFC = `https://release.sears.com.mx/c/rfc/`
    }else{
        urlRFC = `/c/rfc/`
    }

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);
    const handleClose = () => SetShowModal(false);
    useEffect(()=>{
        if(errorCode <= 499){
            showModalErrorCode()
        }
        if(errorCode?.codMen?.indexOf('ERR') >= 0 ){
            showModalErrorCode()
        }
        
    },[errorCode])


    // banderas para mostrar ayuda inputs
    const [flagNumero, setFlagNumero] = useState(false);
    const [, setFlagTitular] = useState(false);

    const [datosTarjeta, setDatosTarjeta] = useState(false);
    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            numero: datosTarjeta.numero,
            rfc: datosTarjeta.rfc
        }
    });

    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);

    //- valores por default que muestra la tarjeta
    const [numeroCard, setNumeroCard] = useState();
    const [rfcT, setRfcT] = useState();

    //- valores para agregar tarjeta
    const [inputNumberCard, setInputNumberCard] = useState();
    const [inputRfcT, setInputRfcT] = useState();
    const [inputPhoneT, setInputPhoneT] = useState();

    useEffect(()=>{
        if(inputNumberCard){
            if(inputNumberCard.length != 0){
                setNumeroCard(inputNumberCard)
            }
        }else{
            setNumeroCard("**** **** ****")
        }
        
    },[inputNumberCard])

    // guarda la informacion enviada en el formulario
    const sendFormInformacionBancaria = data => {
        setDatos({
            "cardnumber": data.numero,
            "rfc": data.rfc.toUpperCase()
            //"phone_num": data.phone
        })
        SetReturnForm(true);
    };

    // al recibir data del formulario se guarda en variable datos bancarios
    useEffect(() => {
        if (returnForm) {
            setDatosTarjeta(datos);
            setAddCard(datos)
            SetReturnForm(false);
        }
    }, [returnForm])

    //- Validaciones de campos para agregar tarjeta
    const valNumero = {
        required: 'Campo obligatorio',
        minLength: {
            value: 12,
            message: 'Faltan dígitos. Deben ser al menos 12 dígitos'
        },
        maxLength: {
            value: 13,
            message: 'No debe contener más de 13 dígitos'
        },
        pattern: {
            value: /[0-9]{12,13}/,
            message: 'El formato de la tarjeta es inválido'
        }
    }
    const valRfc = {
        required: 'Campo obligatorio',
        minLength: {
            value: 9,
            message: 'El RFC al menos debe de contener 9 carácteres'
        },
        maxLength: {
            value: 10,
            message: 'No debe contener más de 10 carácteres'
        }
    }
    // const valNumTitular = {
    //     required: 'Campo obligatorio',
    //     minLength: {
    //         value: 10,
    //         message: 'El numero de celular del titular debe de contener 10 carácteres'
    //     },
    //     maxLength: {
    //         value: 10,
    //         message: 'El numero de celular del titular debe de contener 10 carácteres'
    //     },
    //     pattern: {
    //         value: /[0-9]{10}/,
    //         message: 'El formato de teléfono es inválido'
    //     }
    // }

    const resetErrors = (value) =>{
        let inputId = document.querySelector(`#${value} ~ .error`)
        if(inputId){
            let valu = value
            clearErrors(valu)
            reset({valu},{
                keepErrors: false, 
                keepDirty: true,
                keepIsSubmitted: false,
                keepTouched: false,
                keepIsValid: false,
                keepSubmitCount: false,
            });
        }
    }

    return (
        <>
            <div className="boxCardFormDesk">
                <div className="cardDesk">
                    <div className="imaTarjetaDesk">
                        <div className="imgDesk" >
                            <div className="numeroTarjeta">
                                <span>{numeroCard}</span>
                            </div>
                            <div className="titular"><span></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="boxcopyFormSears">
                    <p>Llena los siguientes datos tal cual aparecen en tu tarjeta.</p>
                </div>

                <form className="formAgregarTarjetaSearsDesk" onSubmit={handleSubmit(sendFormInformacionBancaria)}>
                    
                    <InputTypeAndroid
                        type="text"
                        name="numero"
                        id="numero"
                        placeholder="Número de tarjeta"
                        refs={register(valNumero)}
                        autocomplete='numero'
                        setNumero={setInputNumberCard}
                        value={inputNumberCard}
                        errorMessage={errors.numero && errors.numero.message}
                        pattern={'number'}
                        minLength={12}
                        maxLength={13}
                        max="9999999999999"
                        click={() => resetErrors('numero')}
                    />

                    {/* <InputTypeAndroid
                        type="text"
                        name="phone"
                        id="phone"
                        placeholder="Numero de teléfono"
                        refs={register(valNumTitular)}
                        autocomplete='phone'
                        setNumero={setInputPhoneT}
                        value={inputPhoneT}
                        errorMessage={errors.phone && errors.phone.message}
                        maxLength={10}
                        minLength={10}
                        pattern={'number'}
                    /> */}
                    
                    <InputTypeAndroid
                        type="text"
                        name="rfc"
                        id="rfc"
                        placeholder="RFC (sin homoclave)"
                        refs={register(valRfc)}
                        autocomplete='rfc'
                        setNumero={setInputRfcT}
                        value={inputRfcT}
                        minLength={10}
                        maxLength={10}
                        errorMessage={errors.rfc && errors.rfc.message}
                        pattern={'textOnly'}
                        click={() => resetErrors('rfc')}
                    />
                    <p className="linkRFC">No conozco mi RFC,  <a href={urlRFC} target="_blank" className="link">¿Qué puedo hacer?</a></p>

                   

                    <div className="boxBtnGuardarSearsDesk">
                        <button className="btnGuardarCard">Agregar tarjeta</button>
                    </div>
                </form>
            </div>
            {showModal &&
                <ModalError errorCode={errorCode} section={'addCardSears'} handleClose={handleClose} />
            }
        </>
    )
}



export function OldTarjetaSears(props) {
    const {
        setAddCard,
        errorCode
    } = props

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);
    const handleClose = () => SetShowModal(false);
    useEffect(()=>{
        if(errorCode){
            showModalErrorCode()
        }
    },[errorCode])


    // banderas para mostrar ayuda inputs
    const [flagNumero, setFlagNumero] = useState(false);
    const [, setFlagTitular] = useState(false);

    const [datosTarjeta, setDatosTarjeta] = useState(false);
    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            numero: datosTarjeta.numero,
            titular: datosTarjeta.titular,
            phone: datosTarjeta.phone
        }
    });

    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);

    //- valores por default que muestra la tarjeta
    const [numeroCard, setNumeroCard] = useState();
    const [titularT, setTitularT] = useState();

    //- valores para agregar tarjeta
    const [inputNumberCard, setInputNumberCard] = useState();
    const [inputTitularT, setInputTitularT] = useState();
    const [inputPhoneT, setInputPhoneT] = useState();

    useEffect(()=>{
        if(inputNumberCard){
            if(inputNumberCard.length != 0){
                setNumeroCard(inputNumberCard)
            }
        }else{
            setNumeroCard("**** **** ****")
        }
        if(inputTitularT){
            if(inputTitularT.length != 0){
                setTitularT(inputTitularT)
            }
        }else{
            setTitularT("Nombre del titular")
        }
    },[inputNumberCard, inputTitularT])

    // guarda la informacion enviada en el formulario
    const sendFormInformacionBancaria = data => {
        setDatos({
            "cardnumber": data.numero,
            "username": data.titular,
            "phone_num": data.phone
        })
        SetReturnForm(true);
    };

    // al recibir data del formulario se guarda en variable datos bancarios
    useEffect(() => {
        if (returnForm) {
            setDatosTarjeta(datos);
            setAddCard(datos)
            SetReturnForm(false);
        }
    }, [returnForm])

    //- Validaciones de campos para agregar tarjeta
    const valNumero = {
        required: 'Campo obligatorio',
        minLength: {
            value: 12,
            message: 'Faltan dígitos. Deben ser al menos 12 dígitos'
        },
        maxLength: {
            value: 13,
            message: 'No debe contener más de 13 dígitos'
        },
        pattern: {
            value: /[0-9]{12,13}/,
            message: 'El formato de la tarjeta es inválido'
        }
    }
    const valTitular = {
        required: 'Campo obligatorio',
        minLength: {
            value: 6,
            message: 'El nombre del titular al menos debe de contener 6 carácteres'
        }
    }
    const valNumTitular = {
        required: 'Campo obligatorio',
        minLength: {
            value: 10,
            message: 'El numero de celular del titular debe de contener 10 carácteres'
        },
        maxLength: {
            value: 10,
            message: 'El numero de celular del titular debe de contener 10 carácteres'
        },
        pattern: {
            value: /[0-9]{10}/,
            message: 'El formato de teléfono es inválido'
        }
    }



    return (
        <>
            <div className="boxCardFormDesk">
                <div className="cardDesk">
                    <div className="imaTarjetaDesk">
                        <div className="imgDesk" >
                            <div className="numeroTarjeta">
                                <span>{numeroCard}</span>
                            </div>
                            <div className="titular"><span>{titularT}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="boxcopyFormSears">
                    <p>Llena los siguientes datos tal cual aparecen en tu tarjeta.</p>
                </div>

                <form className="formAgregarTarjetaSearsDesk" onSubmit={handleSubmit(sendFormInformacionBancaria)}>
                    
                    <InputTypeAndroid
                        type="text"
                        name="numero"
                        id="numero"
                        placeholder="Número de tarjeta"
                        refs={register(valNumero)}
                        autocomplete='numero'
                        setNumero={setInputNumberCard}
                        value={inputNumberCard}
                        errorMessage={errors.numero && errors.numero.message}
                        pattern={'number'}
                        minLength={12}
                        maxLength={13}
                        max="9999999999999"
                    />
                    
                    <InputTypeAndroid
                        type="text"
                        name="titular"
                        id="titular"
                        placeholder="Nombre del titular"
                        refs={register(valTitular)}
                        autocomplete='titular'
                        setNumero={setInputTitularT}
                        value={inputTitularT}
                        errorMessage={errors.titular && errors.titular.message}
                        pattern={'textOnly'}
                    />

                    <InputTypeAndroid
                        type="text"
                        name="phone"
                        id="phone"
                        placeholder="Numero celular"
                        refs={register(valNumTitular)}
                        autocomplete='phone'
                        setNumero={setInputPhoneT}
                        value={inputPhoneT}
                        errorMessage={errors.phone && errors.phone.message}
                        maxLength={10}
                        minLength={10}
                        pattern={'number'}
                    />

                    <div className="boxBtnGuardarSearsDesk">
                        <button className="btnGuardarCard">Agregar tarjeta</button>
                    </div>
                </form>
            </div>
            {showModal &&
                <ModalError errorCode={errorCode} section={'addCardSears'} handleClose={handleClose} />
            }
        </>
    )
}